<template>
  <div>
    <b-row align-h="between">
            <b-col>
                <h5 class="text-secondary">Sales</h5>
            </b-col>
            <b-col class="text-right">
              <b-button v-b-modal.salesModal variant="outline-secondary" size="sm" :disabled="orders.length < 1">
                <b-icon-receipt></b-icon-receipt>
                <span class="ml-2 mr-1">Details <b-badge class="ml-1" v-if="!loading">{{ orders.length }}</b-badge></span>
              </b-button>
            </b-col>
        </b-row>
      <div class="tableHolder">
      <b-table :items="orders"
                    :fields="fields"
                    small
                    striped
                    thead-class="p-0"
                    class="salesTable"
                    :busy="loading"
          >
          <template #table-busy>
            <div class="text-center text-secondary my-2">
              <b-spinner class="align-middle sm"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(orderDate)="data">
              <span class="cellText">{{ moment(data.item.platform.date).format('M/D/YY') }}</span>
          </template>

          <template #cell(price)="data">
              <span class="text-success cellText">${{ getPrice(data.item) }}</span>
          </template>

          <template #cell(grade)="data">
                <span class="cellText">{{ getGrade(data.item) }}</span>
          </template>

          <template #cell(daysToSell)="data">
                <span class="cellText">{{ getDaysToSell(data.item) }}</span>
          </template>

          <template #cell(platform)="data">
            <b-link :to="{ name: 'orders', params: { outsideQuery: { orderId: data.item.orderId.toString(), query: data.item.orderId.toString(), filters: {} } } }" append >
                <span class="cellText">{{ getPlatform(data.item) }}</span>
            </b-link>
          </template>

      </b-table>
      </div>
      <b-modal centered 
                 size="lg"
                 id="salesModal"
                 hide-footer>
            <template #modal-header>
                <b-col>
                    <h5 class="mb-0 pt-2">Sales - {{ orders.legnth }} {{ orders.length === 1 ? 'order' : 'orders' }}</h5>
                </b-col>
            </template>

            <sales-history :item="item" :orders="orders"></sales-history>
        </b-modal>
  </div>
  
</template>

<script>
  import ordersMixin from "@/api/orders";
  import moment from "moment";
  import SalesHistory from './SalesHistory';

  export default {
      name: "Sales",
      props: [ "item" ],
      components: { SalesHistory },
      mixins: [ ordersMixin ],
      data() {
          return {
              orders: [],
              fields: [
                  { key: 'orderDate', label: 'Date', tdClass: "py-0", thClass: 'bg-white text-secondary font-weight-normal py-0 ' },
                  { key: 'grade', label: 'Grade', tdClass: "py-0",thClass: 'bg-white text-secondary font-weight-normal py-0' },
                  { key: 'price', label: 'Price', tdClass: "py-0",thClass: 'bg-white text-secondary font-weight-normal py-0' },
                  { key: 'daysToSell', label: 'Days', tdClass: "py-0", thClass: 'bg-white text-secondary font-weight-normal py-0'},
                  { key: 'platform', label: 'Platform', tdClass: "py-0", thClass: 'bg-white text-secondary font-weight-normal py-0'}
              ],
              loading: false,
          }
      },
      async created() {
        if (!isNaN(this.item.itemId)) {
          this.loading = true;
          await this.fetchHistory(this.item.itemId);
          this.loading = false;
        }
      },
      methods: {
          async fetchHistory(itemId) {

              const orders = await this.getItemOrders(itemId);

              this.orders = this.addRowVariants(orders, itemId);
          },
          addRowVariants(orders, itemId) {
              for (let i = 0; i < orders.length; i++) {
                  if (orders[i].location === 'Cancelled' || orders[i].location === 'Returned') {
                      orders[i]._rowVariant = 'danger';
                  }

                  for (let k = 0; k < orders[i].items.length; k++) {
                      if (orders[i].items[k].details.itemId === itemId && orders[i].items[k].status && orders[i].items[k].status.type === 'removed') {
                          orders[i]._rowVariant = 'warning';
                      }
                  }
              }

              return orders;
          },
          getItemFromOrder(order) {
              let details = {};

              order.items.forEach(item => {
                  if (parseInt(item.details.itemId) === parseInt(this.item.itemId)) {
                      details = item.details;
                  }
              });

              return details;
          },
          getPrice(order) {
              let item = this.getItemFromOrder(order);


              return item.listing.price ? item.listing.price : 0;
          },
          getGrade(order) {
              let item = this.getItemFromOrder(order);
              let grade = '';

              item.listing.condition.forEach(c => {
                  if (!c.subject || c.subject === 'item' || c.subject === 'disc' || c.subject === 'cassette') {
                      grade = c.grade;
                  }
              });

              return grade;
          },
          getDaysToSell(order) {

            let orderItem = this.getItemFromOrder(order);
            if (!orderItem.listing.date || (!order.platform.date && !order.createdAt)) return 'n/a';
            let lastModified = moment(orderItem.listing.date);
            let salesDate = order.platform.date ? moment(order.platform.date) : moment(order.createdAt);
            const daysToSell = salesDate.diff(lastModified, 'days');
            return daysToSell;
          },
          getPlatform(order) {
            let site = order.platform?.site ? order.platform.site : 'n/a';
            return site;
          },
      }
  }
</script>

<style>
  .tableHolder {
    height: 100px;
    overflow: scroll;
  }

  .cellText {
    font-size: 14px;
  }

  .salesTable > thead {
    font-size: 13px;
  }
</style>